import _ from "lodash";
import moment from "moment";
import * as DateUtils from "../utils/date/date";
import { CNPJMask, formatElapsed, getInitials } from "../utils/format/format";
import { RolesUtils } from "../utils/roles/roles";
import { nucontersUsers } from "../utils/users-roles/users-roles";
import { Entity } from "./Entity.abstract";

export class AccountingEntity extends Entity {
    constructor(props) {
        super(props);
    }

    static restore(props) {
        return new AccountingEntity(props);
    }

    churnIsInProcess() {
        const currentDate = new Date();
        const expirationDate = new Date(
            this.props.churn?.config?.expirationDate
        );

        return currentDate.getTime() < expirationDate.getTime();
    }

    getEndSubscription() {
        return new Date(
            this.props?.churn?.config.expirationDate
        ).toLocaleDateString("pt-BR");
    }

    setPlanCountCompany(count) {
        this.props.plan.countCompany = count;
    }

    setDealFee(value) {
        this.props.deal.fee = value;
    }

    hasAnalysisPlus() {
        return this.props?.plan?.analysisPlus?.limit > 0 ? true : false;
    }

    setPropsByGovernmentData(data) {
        if (data.address)
            this.props.address = {
                zipcode: data.address.zipcode,
                city: data.address.city,
                state: data.address.state,
                street: data.address.street,
                district: data.address.district,
                number: Number(data.address.number),
                complement: ""
            };

        this.props.name = data.fantasyName || "";
        this.props.socialName = data.name || "";
    }

    setAddress(data) {
        this.props.address.city = data.localidade || "";
        this.props.address.state = data.uf || "";
        this.props.address.street = data.logradouro || "";
        this.props.address.district = data.bairro || "";
        this.props.address.complement = data.complemento || "";
        this.props.address.number = null;
    }

    setMaskCNPJ() {
        this.props.documentFormated = CNPJMask(this.props.document);
    }

    setLevelMission() {
        const levels = {
            "bronze 0": "bronze-medal-0",
            "bronze 1": "bronze-medal-1",
            "bronze 2+": "bronze-medal-2",
            bronze: "bronze-medal",
            prata: "default-medal",
            ouro: "gold-medal",
            embaixador: "petroleum-medal"
        };

        if (this.props?.impact?.status)
            this.props.impactStyle = {
                class: levels[this.props?.impact?.status.toLowerCase()],
                label: this.props?.impact.status
            };
    }

    clearEmailAndPassword() {
        this.props.email = "";
        this.props.password = "";
    }

    emailToLowerCase() {
        const email = this.props.email || "";
        const financialEmail = this.props.financialEmail || "";

        this.props.email = email.toLowerCase();
        this.props.financialEmail = financialEmail.toLowerCase();
    }

    setPhoneAndCellphone(phone) {
        this.props.cellphone = this.props.cellphone || phone;
        this.props.phone = this.props.phone || phone;
    }

    setContract(contract) {
        this.props.contract = contract;
    }

    deleteConfirmationPassword() {
        delete this.props.passwordConfirmation;
    }

    toJSON() {
        return {
            id: this.props._id,
            ...this.props
        };
    }

    abbreviationCS() {
        if (_.get(this.props, "responsible.cs"))
            this.props.responsible.csAbbreviation = getInitials(
                _.get(this.props, "responsible.cs")
            );
    }

    formatTotalFees() {
        if (!_.get(this.props, "summary.companies")) return;
        this.props.summary.companies.totalFeesFormated = _.get(
            this.props,
            "summary.companies.totalFees"
        ).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }
    formatTicketMedium() {
        if (!_.get(this.props, "summary.companies")) return;
        this.props.summary.companies.ticketMediumFormated = (
            _.get(this.props, "summary.companies.totalFees") /
            _.get("this.props.summary.companies.total")
        ).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
    }

    changeColorScore() {
        const formated = {
            ALTO: {
                class: "tag-cyan",
                label: "Alto"
            },
            MEDIO: {
                class: "tag-yellow",
                label: "Médio"
            },
            BAIXO: {
                class: "tag-pink",
                label: "Baixo"
            }
        };

        this.props.formatedScore = formated[this.props.score];
    }

    statusSuperlogicaView() {
        const status = {
            ATIVO: "Ativo",
            CONGELADO: "Suspenso",
            INATIVO: "Inativo"
        };

        this.props.status.statusSuperlogicaView =
            status[_.get(this.props, "status.superlogica")] || "";
    }

    createdAtClient() {
        this.props.createdAtFormated = new Date(
            this.props.createdAt
        ).toLocaleDateString();
    }

    elapsedAccess() {
        if (!_.get(this.props, "summary.eventsLastRegister")) return;
        if (!this.props.summary.eventsLastRegister.access) return "";

        this.props.summary.eventsLastRegister.elapsedAccess = formatElapsed(
            _.get(this.props, "summary.eventsLastRegister.access")
        );
    }

    elapsedDateCompanies() {
        if (!_.get(this.props, "summary.eventsLastRegister")) return;
        if (!this.props.summary.eventsLastRegister.companies) return "";

        this.props.summary.eventsLastRegister.elapsedCompanies = formatElapsed(
            _.get(this.props, "summary.eventsLastRegister.companies")
        );
    }

    elapsedInput() {
        if (!_.get(this.props, "summary.eventsLastRegister")) return;
        if (!this.props.summary.eventsLastRegister.input) return "";

        this.props.summary.eventsLastRegister.elapsedInput = formatElapsed(
            _.get(this.props, "summary.eventsLastRegister.input")
        );
    }

    elapsedReport() {
        if (!_.get(this.props, "summary.eventsLastRegister")) return;
        if (!this.props.summary.eventsLastRegister.report) return "";

        this.props.summary.eventsLastRegister.elapsedReport = formatElapsed(
            _.get(this.props, "summary.eventsLastRegister.report")
        );
    }

    documentGeneralData() {
        return {
            accountingName: this.props.name,
            corporateName: this.props.socialName,
            registerNumber: this.props.document,
            accountingSystem: this.props.system,
            telephone: this.props.phone,
            cellPhone: this.props.cellphone,
            postalCode: _.get(this.props, "address.zipcode"),
            state: _.get(this.props, "address.state"),
            city: _.get(this.props, "address.city"),
            district: _.get(this.props, "address.district"),
            logradouro: _.get(this.props, "address.street"),
            number: Number(_.get(this.props, "address.number")) || "",
            complement: _.get(this.props, "address.complement")
        };
    }

    documentPlan() {
        return {
            definitionPlan: this.props.contract,
            amountLicenses: _.get(this.props, "plan.countCompany"),
            analysisPlus: _.get(this.props, "plan.analysisPlus", {
                limit: 0,
                companies: []
            }),
            validity: this.props.termOfThePlan,
            formOfPayment: this.props.formOfPayment,
            monthlyPayment: _.get(this.props, "deal.fee"),
            details: _.get(this.props, "deal.payments.0"),
            implementationValue: _.get(this.props, "deal.setup"),
            implementationDetails: this.props.implementationDetails,
            seller: _.get(this.props, "seller._id"),
            customerSuc: _.get(this.props, "cs._id"),
            persona: this.props.persona,
            dateOfPayment: _.get(this.props, "deal.dayPayment"),
            currencyMonthly: this.props?.superLogica?.mrr || null,
            dealLink: this.props?.deal?.contractLink || null,
            integrations: this.props?.plan?.integrations || {}
        };
    }

    documentAccess() {
        return {
            picture: this.props.picture,
            definitionAccess: this.props.roles,
            status: this.props.status,
            financialEmail: this.props.financialEmail,
            accessEmail: this.props.email,
            password: this.props.password,
            passwordConfirmation: this.props.passwordConfirmation,
            contact: this.props.contact.name,
            whatsapp: this.props?.whatsapp || null
        };
    }

    getRenovationActivatedLabel(path) {
        const renovationActivated = this.renovationActivated(path);
        if (renovationActivated) return "Ativada";
        else return "Desativada";
    }

    renovationActivated(path) {
        if (!(path in this.props)) return true;

        if (!("automaticRenovation" in this.props[path])) return true;

        return this.props[path].automaticRenovation;
    }

    activateAutomaticRenovation(path) {
        _.set(this.props, `${path}.automaticRenovation`, true);
    }

    deactivateAutomaticRenovation(path) {
        _.set(this.props, `${path}.automaticRenovation`, false);
    }

    setIsAnalysisPlusWithCompany(companyData, contracted) {
        if (companyData._id === "EMPRESA_MODELO" || contracted) {
            this.props.isAnalysisPlusWithCompany = {
                statusAccounting: true,
                statusCompany: true
            };
            return;
        }
        const accountingAnalysisPlanLimit =
            _.get(this.props, "plan.analysisPlus.limit") || 0;

        const companyAnalysisPlanStatus =
            companyData?.analytics?.analysisPlus?.status;

        this.props.isAnalysisPlusWithCompany = {
            message: "Funcionalidade disponível apenas para Análise Plus."
        };

        if (accountingAnalysisPlanLimit <= 0) {
            this.props.isAnalysisPlusWithCompany.statusCompany = false;
            this.props.isAnalysisPlusWithCompany.statusAccounting = false;
        } else if (
            accountingAnalysisPlanLimit > 0 &&
            !companyAnalysisPlanStatus
        ) {
            this.props.isAnalysisPlusWithCompany.statusAccounting = true;
            this.props.isAnalysisPlusWithCompany.statusCompany = false;
        } else {
            this.props.isAnalysisPlusWithCompany.statusAccounting = true;
            this.props.isAnalysisPlusWithCompany.statusCompany = true;
            this.props.isAnalysisPlusWithCompany.message =
                "Ao ativar a taxa fixa, será aplicado em todas as contas do plano de contas o percentual inserido.";
        }
    }

    hasCompanyAnalysisPlus() {
        return this.props.isAnalysisPlusWithCompany.statusCompany;
    }

    hasAccountingAnalysisPlus() {
        return this.props.isAnalysisPlusWithCompany.statusAccounting;
    }

    churn() {
        this.props.status.internal = "CHURN";
    }

    setAnalysisPlus(limit) {
        this.props.isAnalysisPlusWithCompany = {
            statusAccounting: true
        };

        if (!_.get(this.props, "plan.analysisPlus")) {
            this.props.plan.analysisPlus = {
                companies: [],
                limit
            };
        } else {
            this.props.plan.analysisPlus.limit = limit;
        }
    }

    activateAnalysisPlus(companyData, status) {
        this.props.isAnalysisPlusWithCompany = {
            statusCompany: status
        };

        companyData.events.analysisPlus = {
            status,
            date: new Date()
        };
    }

    isAccessBlockedByFinancial({ user }) {
        const isNuconter = RolesUtils.userIsInRole({
            user,
            roles: nucontersUsers
        });
        if (isNuconter) return false;
        return this.isBlockedByFinancial();
    }

    isBlockedByFinancial() {
        if (["BLOQUEADO", "BLOQUEADO FINANCEIRO"].includes(this.props.status))
            return true;
        return false;
    }

    isChurn() {
        return this.props.status === "CHURN";
    }

    isDefaulter() {
        if (
            this.props.superLogica?.expiredTickets &&
            _.size(this.props, "superLogica.expiredTickets")
        ) {
            const firstDate = _.min(this.props.superLogica.expiredTickets);

            const result =
                moment().diff(moment(firstDate), "days") >= 4 ? true : false;

            return result;
        }
        return false;
    }

    getDaysRemaining(phrase = "restante") {
        if (!this.props?.status?.rescission?.daysRemaining) return null;

        const status = this.props?.status?.rescission?.status;
        const daysRemaining = this.props?.status?.rescission?.daysRemaining;

        if (status === "encerrado") return null;

        return `${daysRemaining} ${
            daysRemaining > 1 ? `dias ${phrase}s` : `dia ${phrase}`
        }`;
    }

    getStatusRecission() {
        const status = this.props?.status?.rescission?.status;
        const recissionStatus = {
            aguardando:
                '<i class="fas fa-exclamation-triangle color-yellow-dark margin-r-smaller"></i> Em aviso prévio',
            encerrado: "Contrato Encerrado"
        };

        return recissionStatus[status] || "-";
    }

    getExpiredTickets() {
        const expiredTickets = this.props.superLogica.expiredTickets;
        return `${expiredTickets.length} ${
            expiredTickets.length > 1 ? `faturas atrasadas` : "fatura atrasada"
        }`;
    }

    getAccountingBasis(system) {
        return this.props.integrations?.[system]?.accountingBasis;
    }
    setAccountingBasisDefaultIntegration(system, defaultBasis) {
        if (this.props?.integrations?.[system]?.accountingBasis?.default)
            return;

        _.set(
            this.props,
            `integrations.${system}.accountingBasis.default`,
            defaultBasis
        );
    }

    setAccountingBasisIntegration(system, accountingBasis) {
        _.set(
            this.props,
            `integrations.${system}.accountingBasis`,
            accountingBasis
        );
    }

    setIntegrationCredentials(credentials, system) {
        const _system = ["Serpro", "serpro", "eSocial"].includes(system)
            ? "Serpro"
            : system;
        _.set(
            this.props,
            `integrations.${_system}.document`,
            credentials.document
        );
        _.set(
            this.props,
            `integrations.${_system}.socialName`,
            credentials.socialName
        );
    }

    getIntegrationCredentials(system = "") {
        const _system = ["Serpro", "serpro", "eSocial"].includes(system)
            ? "Serpro"
            : system;
        const credentials = {
            socialName: this.props.socialName,
            document: this.props.document
        };
        if (this.props.integrations?.[_system]?.document) {
            credentials.document = this.props.integrations?.[_system]?.document;
            credentials.socialName = this.props.integrations?.[
                _system
            ]?.socialName;
        }
        return credentials;
    }

    setIntegrationMaskCNPJ(system = "") {
        const _system = ["Serpro", "serpro", "eSocial"].includes(system)
            ? "Serpro"
            : system;
        const credentials = this.getIntegrationCredentials(_system);
        this.props.serproDocumentFormated = CNPJMask(credentials.document);
    }

    setPreferenceDominio(value) {
        _.set(this.props, "preferences.dominioView", value);
    }

    getPreferenceDominio() {
        return typeof this.props.preferences?.dominioView === "undefined"
            ? true
            : this.props.preferences?.dominioView;
    }

    getTotalEsocialLicenses() {
        return (
            (this.props.plan?.integrations?.eSocial?.totalCourtesies || 0) +
            (this.props.plan?.integrations?.eSocial?.totalLicenses || 0)
        );
    }

    updateEsocialLicenses(licenses) {
        const totalLicenses =
            this.props.plan?.integrations?.eSocial?.totalLicenses + licenses;
        _.set(
            this.props,
            "plan.integrations.eSocial.totalLicenses",
            totalLicenses
        );
    }

    getIntegrationsSourcesPreference(system) {
        return (
            this.props.preferences?.[system]?.sources || [
                { source: "accounting" }
            ]
        );
    }

    setIntegrationsSourcesPreference(system, sources) {
        _.set(this.props, `preferences.${system}.sources`, sources);
    }

    integrationIsBeforeDate(integration, date = new Date()) {
        if (!this.props.integrations?.[integration]?.firstIntegration)
            return false;
        const firstIntegration = new Date(
            this.props.integrations?.[integration]?.firstIntegration
        );
        if (!firstIntegration) return false;
        const { days } = DateUtils.elapsed(date, firstIntegration);
        return days < 0;
    }

    get lastDateReportShared() {
        const date = new Date(this.props.impact.lastDate);
        if (date.getUTCFullYear() <= 1970) return null;
        return this.props.impact.lastDate
            ? date.toLocaleDateString("pt-br")
            : null;
    }

    getSerproIntegrationInfo() {
        const serpro = this.props.integrations?.Serpro;
        if (!serpro) return null;

        const today = new Date();
        const validityDate = serpro.validityDate
            ? new Date(serpro.validityDate)
            : null;
        const certValidityDate = serpro.certificateValidityDate
            ? new Date(serpro.certificateValidityDate)
            : null;

        const dueDate = [validityDate, certValidityDate].sort(
            (a, b) => b - a
        )[0];

        if (!dueDate) return null;

        const diffTime = dueDate - today;
        const daysToExpire = Math.max(
            Math.ceil(diffTime / (1000 * 60 * 60 * 24)),
            0
        );
        const formattedDueDate = dueDate.toLocaleDateString("pt-BR");
        const unit = daysToExpire < 2 ? "dia" : "dias";
        const labelDate = `${daysToExpire} ${unit}`;

        const status =
            daysToExpire <= 0
                ? "expired"
                : daysToExpire <= 30
                ? "expiringSoon"
                : null;

        return {
            daysToExpire,
            formattedDueDate,
            labelDate,
            status,
            disabled: status === "expiringSoon" ? false : !!status
        };
    }
}
